export const REDUX_SLICE = {
  APP: 'app',
  NODE_API: 'nodeApi',
  NETWORK_API: 'networkApi',
} as const;
